import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'components/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.scss';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

export default function IncompleteDealFlag({ deal, onClick }) {
  if (!deal.incomplete) {
    return null;
  }

  let flag = (
    <div className="incomplete-deal-flag">
      <FontAwesomeIcon icon={faCircleExclamation} />
    </div>
  );

  if (onClick) {
    flag = (
      <Tooltip
        content="Click to add missing information"
        dark
        overlayClassName="incomplete-deal-flag-tooltip"
        onClick={onClick}
      >
        {flag}
      </Tooltip>
    );
  }

  return flag;
}

IncompleteDealFlag.propTypes = {
  deal: PropTypes.shape({
    incomplete: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func,
};
